import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withStateHandlers, withHandlers, withPropsOnChange } from 'recompose'
import { patchOperations } from 'utils/PatchHelper'
import withOrgTeamAvailabilities from 'app/modules/teams/hoc/withOrgTeamAvailabilities'
import withNotifications from 'components/shared/notifications'
import { withRouter } from 'react-router'

import { patchTeamPending } from 'app/modules/teams/selectors'
import { patchOrgTeam } from 'app/modules/teams/actions'

import TeamAutoOfflineManager from './component'

const mapStateToProps = state => {
  return {
    patchTeamPending: patchTeamPending(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      patchOrgTeam,
    },
    dispatch
  ),
})

export default compose(
  withRouter,
  withNotifications,
  withOrgTeamAvailabilities,
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    ({ team }) => ({
      autoOffline: team.autoOffline,
    }),
    {
      setAutoOffline: () => autoOffline => ({
        autoOffline,
      }),
    }
  ),
  withHandlers({
    handleChangeAutoOfflineToggle: props => event => {
      props.setAutoOffline(event.target.checked)
      const ops = patchOperations({
        autoOffline: event.target.checked,
      })
      props.actions.patchOrgTeam({ teamId: props.team.id, properties: ops })
    },
  }),
  withPropsOnChange(['team'], ({ setAutoOffline, team }) => {
    !!team && setAutoOffline(team.autoOffline)
  })
)(TeamAutoOfflineManager)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamAutoOfflineManager/index.js